'use client';
import { memo, useState } from 'react';
import { HStack, VStack } from '@chakra-ui/react';

import { breakpoints } from 'app/themeConfig';
import SliderControls from 'features/SliderControls';
import ExpertiseCard from 'entities/ExpertiseCard';
import { useSwiperControls } from 'shared/hooks';
import AnimatedText from 'shared/AnimatedText';
import BlockHeader from 'shared/BlockHeader';
import Slider from 'shared/Slider';

import { expertiseCardsSliderPropsSelector } from 'constants/ExpertiseCardsSlider';

const ExpertiseCardsSlider = ({ type }) => {
  const {
    title = null,
    textTitle = null,
    titleProps = null,
    cardsData,
    cardsStyles = null,
  } = expertiseCardsSliderPropsSelector[type];

  const [swiper, setSwiper] = useState(null);
  const controls = useSwiperControls(swiper);

  return (
    <VStack
      as="section"
      w="full"
      align="start"
      gap={{ mobile: '24px', tablet: '32px', laptop: '48px' }}
    >
      <HStack w="full" justify="space-between" align="end">
        {title && <BlockHeader {...titleProps}>{title}</BlockHeader>}
        {textTitle && (
          <AnimatedText as="h2" duration={700} {...titleProps}>
            {textTitle}
          </AnimatedText>
        )}

        <SliderControls {...controls} />
      </HStack>

      <Slider
        controller={swiper}
        setController={setSwiper}
        SlideComponent={ExpertiseCard}
        slidesData={cardsData}
        slideStyle={cardsStyles}
        mousewheel={false}
        breakpoints={{ [parseInt(breakpoints.xm)]: { slidesPerView: 'auto' } }}
      />
    </VStack>
  );
};

export default memo(ExpertiseCardsSlider);
